import {
  DataSnapshot,
  off,
  onValue,
  ref,
  remove,
  update,
} from "firebase/database";
import store from "store";
import { database } from "../../services/firebaseService/firebaseConfig";
import { THEATER_PATH } from "../theater/firebase";
import { setUserProblemData } from "./redux/actions";
import { IUserProblem } from "./redux/types";

const getUserProblemsDocRef = (theaterId: string) =>
  ref(database, `${THEATER_PATH}/${theaterId}/Problems`);

const getUserProblemsDocRefWithUserId = (theaterId: string, userId: string) =>
  ref(database, `${THEATER_PATH}/${theaterId}/Problems/${userId}`);

export const subscribeToUserProblemReports = (theaterId: string) => {
  const docRef = getUserProblemsDocRef(theaterId);

  off(docRef);
  onValue(docRef, (snap: DataSnapshot) => {
    const data = snap.val();

    store.dispatch(setUserProblemData(data));
  });
};

export const unsubscribeToUserProblemReports = (
  theaterId: string,
  userId: string,
) => {
  off(getUserProblemsDocRef(theaterId));
  remove(getUserProblemsDocRefWithUserId(theaterId, userId));
};

export const reportUserProblemFirebase = (
  data: IUserProblem,
  theaterId: string,
  userId: string,
) => {
  update(getUserProblemsDocRefWithUserId(theaterId, userId), data);
};
